import { render } from 'preact';
import { Acceso, Entrar } from './pages/Acceso.tsx';
import { Admin } from './pages/Admin.tsx';
import { Home } from './pages/Home.tsx';
import { Legislador } from './pages/Legislador.tsx';
import { Pantalla } from './pages/Pantalla.tsx';
import { Presidencia } from './pages/Presidencia.tsx';
import './styles.css';

function App() {
  const path = location.pathname.replace(/\/+$/, '') || '/';
  const screen = /^\/pantalla\/([0-9a-f-]{36})$/i.exec(path);
  if (screen) return <Pantalla eventId={screen[1]!} />;
  switch (path) {
    case '/legislador': return <Legislador />;
    case '/acceso': return <Acceso />;
    case '/entrar': return <Entrar />;
    case '/presidencia': return <Presidencia />;
    case '/admin': return <Admin />;
    case '/': return <Home />;
    default: return <div class="app narrow"><p class="error">Esta página no existe. <a href="/">Ir al inicio</a></p></div>;
  }
}

render(<App />, document.getElementById('app')!);

if ('serviceWorker' in navigator && import.meta.env.PROD) {
  navigator.serviceWorker.register('/sw.js').catch(() => {});
}
